import { formatUIDate } from 'utils/helpers'
import { LegalEntity } from '../LegalEntity'

//TODO add type definitions for the items
export const toTableRowItems = (items: any[]): any[] =>
  items.map(item => ({
    id: item.id,
    name: item.name ?? '',
    legalEntity: item.legalEntity?.name ?? '',
    activeAssignmentsCount: item.activeAssignmentsCount || 'No active assignments',
    status: item.isEnabled ? { name: 'Enabled' } : { name: 'Disabled' },
    metiCode: item.metiCode ?? '',
    sapCode: item.sapCode ?? ''
  }))
